if (window.location.pathname == '/cart' && window.location.search.indexOf('?refid=') > -1) {
  const reference_id = window.location.search.replace('?refid=', '');
  add_atbit_configuration_to_cart(reference_id);
}

function add_atbit_configuration_to_cart(reference_id) {
    document.getElementById('loader-wrapper').style.display = 'flex';
    fetch("/apps/micasa/api/v1/configurations/receive", {
        method: "POST", 
        headers: {"content-type": "application/json"}, 
        body: JSON.stringify({"reference_id": reference_id})
    }).then(e=>e.json()).then(function(e) {
        console.log("e", e);
        const form = {
            items: []
        };
    
        const items = e?.data?.items;
        for (i = 0, l = items.length; i < l; i++) {
            console.log(items[i]);
            form.items.push({
            id: items[i].shopify_id,
            quantity: items[i].quantity,
            properties: {
                __atbit_configuration: reference_id,
                __atbit_image: e?.data?.image,
                __atbit_text: e?.data?.text
            }
            });
        };

        if (items.length > 0) {
            fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                'Content-Type': 'application/json'
                },
                body: JSON.stringify(form)
            })
            .then(response => {
                return response.json();
            }).then(function(response) {
                console.log("response", response);
                if (response.status == undefined) {
                    document.location.href = window.Shopify.routes.root + 'cart';
                } else {
                    document.getElementById('loader-wrapper').style.display = 'none';
                    alert("Ihre gewählte Konfiguration ist aktuell online leider nicht verfügbar. Schon bald steht sie Ihnen wieder zur Verfügung. Alternativ können Sie Ihre Wunschkonfiguration jederzeit in einer unserer Filialen bestellen.");
                }
            })
            .catch((error) => {
                console.error('Error:', error);
                document.getElementById('loader-wrapper').style.display = 'none';
                alert("Ihre gewählte Konfiguration ist aktuell online leider nicht verfügbar. Schon bald steht sie Ihnen wieder zur Verfügung. Alternativ können Sie Ihre Wunschkonfiguration jederzeit in einer unserer Filialen bestellen.");
            });
        } else {
            document.getElementById('loader-wrapper').style.display = 'none';
            if (confirm("Das Produkt scheint nicht konfiguriert zu sein - zurück zum Konfigurator?")) {
              document.location.href = "https://micasa.atbit-konfigurator.de/?mode=embed&reset=setup&lang=de&jsid=1&returnurl=http%3A%2F%2Fmicasa-dev.myshopify.com%2Fcart%3Frefid%3D&refid=" + reference_id;
            }
        }
    });
}